import React, { Component, Fragment } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { Timeline } from '@components/common';

class StatusHistory extends Component {
	shouldComponentUpdate = ({ data }) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.data, data)
		);
	};

	render() {
		const { data } = this.props;
		return (
			<Fragment>
				<Choose>
					<When condition={data.length}>
						<div className="flex margin-bottom-20">
							<i className="rkf rkf-clock-revert" />
							<span className="flex-1 font-size-12 padding-left-5">See all activities on this invoice</span>
						</div>
						<Timeline
							data={data}
							outerClassName="margin-bottom-0"
						/>
					</When>
					<Otherwise>
						<div className="margin-bottom-10 margin-top-10 flex-center">
							<span className="font-size-14 font-light">Nothing to display.</span>
						</div>
					</Otherwise>
				</Choose>
			</Fragment>
		);
	}
}

StatusHistory.propTypes = {
	data : PropTypes.array,
};

StatusHistory.defaultProps = {
	data : [],
};

export default StatusHistory;
